import { render, staticRenderFns } from "./staff-loan-v3.vue?vue&type=template&id=378ba979&scoped=true&"
import script from "./staff-loan-v3.vue?vue&type=script&lang=js&"
export * from "./staff-loan-v3.vue?vue&type=script&lang=js&"
import style0 from "./staff-loan-v3.vue?vue&type=style&index=0&id=378ba979&scoped=true&lang=css&"
import style1 from "./staff-loan-v3.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378ba979",
  null
  
)

export default component.exports